import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `discover:` scope (F62), following the
 * `search:`/`sharing:` precedent — see `apps/web/src/features/search/
 * search.i18n.ts` for the pattern this mirrors. NOT a second i18n runtime
 * (E18/§13.3 ban); `packages/i18n/**` is outside this task's ownership.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/discover.json`.
 */
const en = {
  'page.eyebrow': 'Public library',
  'page.title': 'Discover what others are making',
  'page.searchCta': 'Search all documents',
  'filters.categories.all': 'All categories',
  'card.by': 'by {name}',
  'card.open': 'Open',
  'empty.firstUse.title': 'Nothing public yet',
  'empty.firstUse.description': 'When someone publishes a document, it shows up here.',
  'empty.noResults.title': 'No documents in this category',
  'empty.noResults.description': 'Try a different category.',
  'empty.error.title': "Couldn't load Discover.",
  'detail.notFound.title': "This isn't public.",
  'detail.notFound.description': 'The link may be wrong, or the owner made this private.',
  'detail.notFound.cta': 'Back to Discover',
  'detail.error.title': "Couldn't load this document.",
  'detail.takenDown.title': 'This was removed',
  'detail.takenDown.description': 'A moderator removed this from Discover.',
} as const;

const ro: Record<keyof typeof en, string> = {
  'page.eyebrow': 'Bibliotecă publică',
  'page.title': 'Descoperă ce fac alții',
  'page.searchCta': 'Caută în toate documentele',
  'filters.categories.all': 'Toate categoriile',
  'card.by': 'de {name}',
  'card.open': 'Deschide',
  'empty.firstUse.title': 'Nimic public încă',
  'empty.firstUse.description': 'Când cineva publică un document, apare aici.',
  'empty.noResults.title': 'Niciun document în această categorie',
  'empty.noResults.description': 'Încearcă o altă categorie.',
  'empty.error.title': 'Nu am putut încărca Descoperă.',
  'detail.notFound.title': 'Asta nu este public.',
  'detail.notFound.description': 'Linkul poate fi greșit, sau proprietarul a făcut asta privat.',
  'detail.notFound.cta': 'Înapoi la Descoperă',
  'detail.error.title': 'Nu am putut încărca acest document.',
  'detail.takenDown.title': 'Asta a fost eliminat',
  'detail.takenDown.description': 'Un moderator a eliminat asta din Descoperă.',
};

export const DISCOVER_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type DiscoverCatalogKey = keyof typeof en;
